import { Button, Typography } from 'ui';
import { useGetAllGeographiesQuery, useGetCollectionsForGeographyQuery } from 'generated/graphql';
import { useNavigate, useParams } from 'react-router-v7';
import ClowncarBodyV2 from 'components/ClowncarBodyV2';
import ClowncarHeaderV2 from 'components/ClowncarHeaderV2';
import JceGeographyDetail from 'components/jceGeographyDetail/JceGeographyDetail';
import JceGeographyEditAttributes from 'components/jceGeographyDetail/JceGeographyEditAttributes';
import React from 'react';

const JceHomepageGeographyDetailRoute: React.FC = () => {
  const { geographyId = '-1' } = useParams<{ geographyId: string }>();
  const navigate = useNavigate();

  const { data: geographiesData } = useGetAllGeographiesQuery();
  const geography = geographiesData?.allGeographies?.find((g) => String(g.id) === geographyId);

  const { loading } = useGetCollectionsForGeographyQuery({
    variables: { geographyId: Number(geographyId) },
  });

  return (
    <div className="Content">
      <ClowncarHeaderV2
        heading={geography ? `${geography.name} (#${geographyId})` : `Geography #${geographyId}`}
        actions={
          <Button variant="outlined" onClick={() => navigate(-1)}>
            ← Back
          </Button>
        }
      />
      <ClowncarBodyV2 isLoading={loading}>
        {geography ? (
          <>
            <Typography variant="heading1Medium" mb={2}>
              Geography Attributes
            </Typography>
            <JceGeographyEditAttributes
              geographyId={geography.id}
              initialValues={{
                name: geography.name ?? '',
                urlSlug: geography.urlSlug ?? '',
                resyBlogKey: geography.resyBlogKey ?? '',
                tier: geography.tier ?? 'TIER_THREE',
                priorityWithinTier: geography.priorityWithinTier ?? 0,
              }}
            />
            <Typography variant="heading1Medium" mt={4} mb={2}>
              Collections
            </Typography>
            <JceGeographyDetail geographyId={geographyId} />
          </>
        ) : null}
      </ClowncarBodyV2>
    </div>
  );
};

export default JceHomepageGeographyDetailRoute;
